export const NUMS = [
	'0',
	'3',
	'2',
	'1',
	'6',
	'5',
	'4',
	'9',
	'8',
	'7',
	'=',
	'+',
	'-',
	'C',
];
